/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as UserSignUpRouteImport } from './routes/user-sign-up'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CreateAccountRouteImport } from './routes/create-account'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as InvitationsTokenRouteImport } from './routes/invitations/$token'
import { Route as AuthenticatedBillingRouteImport } from './routes/_authenticated/billing'
import { Route as AuthenticatedToolsRouteRouteImport } from './routes/_authenticated/tools/route'
import { Route as AuthenticatedDocumentsRouteRouteImport } from './routes/_authenticated/documents/route'
import { Route as AuthenticatedCreditsRouteRouteImport } from './routes/_authenticated/credits/route'
import { Route as AuthenticatedUpdatesIndexRouteImport } from './routes/_authenticated/updates/index'
import { Route as AuthenticatedToolsIndexRouteImport } from './routes/_authenticated/tools/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects/index'
import { Route as AuthenticatedDocumentsIndexRouteImport } from './routes/_authenticated/documents/index'
import { Route as AuthenticatedCreditsIndexRouteImport } from './routes/_authenticated/credits/index'
import { Route as AuthenticatedUpdatesSlugRouteImport } from './routes/_authenticated/updates/$slug'
import { Route as AuthenticatedCreditsUsageRouteImport } from './routes/_authenticated/credits/usage'
import { Route as AuthenticatedProjectsSlugRouteRouteImport } from './routes/_authenticated/projects/$slug/route'
import { Route as AuthenticatedDocumentsIdRouteRouteImport } from './routes/_authenticated/documents/$id/route'
import { Route as AuthenticatedToolsBankruptcyScreenerIndexRouteImport } from './routes/_authenticated/tools/bankruptcy-screener/index'
import { Route as AuthenticatedProjectsSlugIndexRouteImport } from './routes/_authenticated/projects/$slug/index'
import { Route as AuthenticatedDocumentsSearchIndexRouteImport } from './routes/_authenticated/documents/search/index'
import { Route as AuthenticatedDocumentsIdIndexRouteImport } from './routes/_authenticated/documents/$id/index'
import { Route as AuthenticatedToolsBankruptcyScreenerFilingIdRouteImport } from './routes/_authenticated/tools/bankruptcy-screener/$filingId'
import { Route as AuthenticatedProjectsSlugWorkbenchRouteImport } from './routes/_authenticated/projects/$slug/workbench'
import { Route as AuthenticatedProjectsSlugTransactionsRouteImport } from './routes/_authenticated/projects/$slug/transactions'
import { Route as AuthenticatedProjectsSlugScreeningRouteImport } from './routes/_authenticated/projects/$slug/screening'
import { Route as AuthenticatedProjectsSlugPortfolioRouteImport } from './routes/_authenticated/projects/$slug/portfolio'
import { Route as AuthenticatedProjectsSlugFilesRouteImport } from './routes/_authenticated/projects/$slug/files'
import { Route as AuthenticatedProjectsSlugChecksRouteImport } from './routes/_authenticated/projects/$slug/checks'
import { Route as AuthenticatedProjectsSlugAnalysisRouteImport } from './routes/_authenticated/projects/$slug/analysis'
import { Route as AuthenticatedProjectsSlugInsightsRouteRouteImport } from './routes/_authenticated/projects/$slug/insights/route'
import { Route as AuthenticatedProjectsFolderSlugIndexRouteImport } from './routes/_authenticated/projects/folder/$slug/index'
import { Route as AuthenticatedDocumentsFolderSlugIndexRouteImport } from './routes/_authenticated/documents/folder/$slug/index'
import { Route as AuthenticatedProjectsSlugInsightsReconciliationRouteImport } from './routes/_authenticated/projects/$slug/insights/reconciliation'
import { Route as AuthenticatedProjectsSlugInsightsNetworkRouteImport } from './routes/_authenticated/projects/$slug/insights/network'
import { Route as AuthenticatedProjectsSlugInsightsMerchantsRouteImport } from './routes/_authenticated/projects/$slug/insights/merchants'
import { Route as AuthenticatedProjectsSlugInsightsIncomeRouteImport } from './routes/_authenticated/projects/$slug/insights/income'
import { Route as AuthenticatedProjectsSlugInsightsFlowOfFundsRouteImport } from './routes/_authenticated/projects/$slug/insights/flow-of-funds'
import { Route as AuthenticatedProjectsSlugInsightsDuplicatesRouteImport } from './routes/_authenticated/projects/$slug/insights/duplicates'
import { Route as AuthenticatedProjectsSlugInsightsCoverageRouteImport } from './routes/_authenticated/projects/$slug/insights/coverage'
import { Route as AuthenticatedProjectsSlugInsightsChecksRouteImport } from './routes/_authenticated/projects/$slug/insights/checks'
import { Route as AuthenticatedProjectsSlugInsightsCategoriesRouteImport } from './routes/_authenticated/projects/$slug/insights/categories'
import { Route as AuthenticatedProjectsSlugInsightsAnomaliesRouteImport } from './routes/_authenticated/projects/$slug/insights/anomalies'
import { Route as AuthenticatedProjectsSlugInsightsDuplicatesGroupIdRouteImport } from './routes/_authenticated/projects/$slug/insights_/duplicates/$groupId'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const UserSignUpRoute = UserSignUpRouteImport.update({
  id: '/user-sign-up',
  path: '/user-sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateAccountRoute = CreateAccountRouteImport.update({
  id: '/create-account',
  path: '/create-account',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const InvitationsTokenRoute = InvitationsTokenRouteImport.update({
  id: '/invitations/$token',
  path: '/invitations/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedBillingRoute = AuthenticatedBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedToolsRouteRoute = AuthenticatedToolsRouteRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDocumentsRouteRoute =
  AuthenticatedDocumentsRouteRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCreditsRouteRoute =
  AuthenticatedCreditsRouteRouteImport.update({
    id: '/credits',
    path: '/credits',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUpdatesIndexRoute =
  AuthenticatedUpdatesIndexRouteImport.update({
    id: '/updates/',
    path: '/updates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedToolsIndexRoute = AuthenticatedToolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedToolsRouteRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDocumentsIndexRoute =
  AuthenticatedDocumentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDocumentsRouteRoute,
  } as any)
const AuthenticatedCreditsIndexRoute =
  AuthenticatedCreditsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCreditsRouteRoute,
  } as any)
const AuthenticatedUpdatesSlugRoute =
  AuthenticatedUpdatesSlugRouteImport.update({
    id: '/updates/$slug',
    path: '/updates/$slug',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCreditsUsageRoute =
  AuthenticatedCreditsUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthenticatedCreditsRouteRoute,
  } as any)
const AuthenticatedProjectsSlugRouteRoute =
  AuthenticatedProjectsSlugRouteRouteImport.update({
    id: '/projects/$slug',
    path: '/projects/$slug',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDocumentsIdRouteRoute =
  AuthenticatedDocumentsIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedDocumentsRouteRoute,
  } as any)
const AuthenticatedToolsBankruptcyScreenerIndexRoute =
  AuthenticatedToolsBankruptcyScreenerIndexRouteImport.update({
    id: '/bankruptcy-screener/',
    path: '/bankruptcy-screener/',
    getParentRoute: () => AuthenticatedToolsRouteRoute,
  } as any)
const AuthenticatedProjectsSlugIndexRoute =
  AuthenticatedProjectsSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProjectsSlugRouteRoute,
  } as any)
const AuthenticatedDocumentsSearchIndexRoute =
  AuthenticatedDocumentsSearchIndexRouteImport.update({
    id: '/search/',
    path: '/search/',
    getParentRoute: () => AuthenticatedDocumentsRouteRoute,
  } as any)
const AuthenticatedDocumentsIdIndexRoute =
  AuthenticatedDocumentsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDocumentsIdRouteRoute,
  } as any)
const AuthenticatedToolsBankruptcyScreenerFilingIdRoute =
  AuthenticatedToolsBankruptcyScreenerFilingIdRouteImport.update({
    id: '/bankruptcy-screener/$filingId',
    path: '/bankruptcy-screener/$filingId',
    getParentRoute: () => AuthenticatedToolsRouteRoute,
  } as any)
const AuthenticatedProjectsSlugWorkbenchRoute =
  AuthenticatedProjectsSlugWorkbenchRouteImport.update({
    id: '/workbench',
    path: '/workbench',
    getParentRoute: () => AuthenticatedProjectsSlugRouteRoute,
  } as any)
const AuthenticatedProjectsSlugTransactionsRoute =
  AuthenticatedProjectsSlugTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AuthenticatedProjectsSlugRouteRoute,
  } as any)
const AuthenticatedProjectsSlugScreeningRoute =
  AuthenticatedProjectsSlugScreeningRouteImport.update({
    id: '/screening',
    path: '/screening',
    getParentRoute: () => AuthenticatedProjectsSlugRouteRoute,
  } as any)
const AuthenticatedProjectsSlugPortfolioRoute =
  AuthenticatedProjectsSlugPortfolioRouteImport.update({
    id: '/portfolio',
    path: '/portfolio',
    getParentRoute: () => AuthenticatedProjectsSlugRouteRoute,
  } as any)
const AuthenticatedProjectsSlugFilesRoute =
  AuthenticatedProjectsSlugFilesRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => AuthenticatedProjectsSlugRouteRoute,
  } as any)
const AuthenticatedProjectsSlugChecksRoute =
  AuthenticatedProjectsSlugChecksRouteImport.update({
    id: '/checks',
    path: '/checks',
    getParentRoute: () => AuthenticatedProjectsSlugRouteRoute,
  } as any)
const AuthenticatedProjectsSlugAnalysisRoute =
  AuthenticatedProjectsSlugAnalysisRouteImport.update({
    id: '/analysis',
    path: '/analysis',
    getParentRoute: () => AuthenticatedProjectsSlugRouteRoute,
  } as any)
const AuthenticatedProjectsSlugInsightsRouteRoute =
  AuthenticatedProjectsSlugInsightsRouteRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => AuthenticatedProjectsSlugRouteRoute,
  } as any)
const AuthenticatedProjectsFolderSlugIndexRoute =
  AuthenticatedProjectsFolderSlugIndexRouteImport.update({
    id: '/projects/folder/$slug/',
    path: '/projects/folder/$slug/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDocumentsFolderSlugIndexRoute =
  AuthenticatedDocumentsFolderSlugIndexRouteImport.update({
    id: '/folder/$slug/',
    path: '/folder/$slug/',
    getParentRoute: () => AuthenticatedDocumentsRouteRoute,
  } as any)
const AuthenticatedProjectsSlugInsightsReconciliationRoute =
  AuthenticatedProjectsSlugInsightsReconciliationRouteImport.update({
    id: '/reconciliation',
    path: '/reconciliation',
    getParentRoute: () => AuthenticatedProjectsSlugInsightsRouteRoute,
  } as any)
const AuthenticatedProjectsSlugInsightsNetworkRoute =
  AuthenticatedProjectsSlugInsightsNetworkRouteImport.update({
    id: '/network',
    path: '/network',
    getParentRoute: () => AuthenticatedProjectsSlugInsightsRouteRoute,
  } as any)
const AuthenticatedProjectsSlugInsightsMerchantsRoute =
  AuthenticatedProjectsSlugInsightsMerchantsRouteImport.update({
    id: '/merchants',
    path: '/merchants',
    getParentRoute: () => AuthenticatedProjectsSlugInsightsRouteRoute,
  } as any)
const AuthenticatedProjectsSlugInsightsIncomeRoute =
  AuthenticatedProjectsSlugInsightsIncomeRouteImport.update({
    id: '/income',
    path: '/income',
    getParentRoute: () => AuthenticatedProjectsSlugInsightsRouteRoute,
  } as any)
const AuthenticatedProjectsSlugInsightsFlowOfFundsRoute =
  AuthenticatedProjectsSlugInsightsFlowOfFundsRouteImport.update({
    id: '/flow-of-funds',
    path: '/flow-of-funds',
    getParentRoute: () => AuthenticatedProjectsSlugInsightsRouteRoute,
  } as any)
const AuthenticatedProjectsSlugInsightsDuplicatesRoute =
  AuthenticatedProjectsSlugInsightsDuplicatesRouteImport.update({
    id: '/duplicates',
    path: '/duplicates',
    getParentRoute: () => AuthenticatedProjectsSlugInsightsRouteRoute,
  } as any)
const AuthenticatedProjectsSlugInsightsCoverageRoute =
  AuthenticatedProjectsSlugInsightsCoverageRouteImport.update({
    id: '/coverage',
    path: '/coverage',
    getParentRoute: () => AuthenticatedProjectsSlugInsightsRouteRoute,
  } as any)
const AuthenticatedProjectsSlugInsightsChecksRoute =
  AuthenticatedProjectsSlugInsightsChecksRouteImport.update({
    id: '/checks',
    path: '/checks',
    getParentRoute: () => AuthenticatedProjectsSlugInsightsRouteRoute,
  } as any)
const AuthenticatedProjectsSlugInsightsCategoriesRoute =
  AuthenticatedProjectsSlugInsightsCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AuthenticatedProjectsSlugInsightsRouteRoute,
  } as any)
const AuthenticatedProjectsSlugInsightsAnomaliesRoute =
  AuthenticatedProjectsSlugInsightsAnomaliesRouteImport.update({
    id: '/anomalies',
    path: '/anomalies',
    getParentRoute: () => AuthenticatedProjectsSlugInsightsRouteRoute,
  } as any)
const AuthenticatedProjectsSlugInsightsDuplicatesGroupIdRoute =
  AuthenticatedProjectsSlugInsightsDuplicatesGroupIdRouteImport.update({
    id: '/insights_/duplicates/$groupId',
    path: '/insights/duplicates/$groupId',
    getParentRoute: () => AuthenticatedProjectsSlugRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/create-account': typeof CreateAccountRoute
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/user-sign-up': typeof UserSignUpRoute
  '/welcome': typeof WelcomeRoute
  '/credits': typeof AuthenticatedCreditsRouteRouteWithChildren
  '/documents': typeof AuthenticatedDocumentsRouteRouteWithChildren
  '/tools': typeof AuthenticatedToolsRouteRouteWithChildren
  '/billing': typeof AuthenticatedBillingRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/': typeof AuthenticatedIndexRoute
  '/documents/$id': typeof AuthenticatedDocumentsIdRouteRouteWithChildren
  '/projects/$slug': typeof AuthenticatedProjectsSlugRouteRouteWithChildren
  '/credits/usage': typeof AuthenticatedCreditsUsageRoute
  '/updates/$slug': typeof AuthenticatedUpdatesSlugRoute
  '/credits/': typeof AuthenticatedCreditsIndexRoute
  '/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tools/': typeof AuthenticatedToolsIndexRoute
  '/updates': typeof AuthenticatedUpdatesIndexRoute
  '/projects/$slug/insights': typeof AuthenticatedProjectsSlugInsightsRouteRouteWithChildren
  '/projects/$slug/analysis': typeof AuthenticatedProjectsSlugAnalysisRoute
  '/projects/$slug/checks': typeof AuthenticatedProjectsSlugChecksRoute
  '/projects/$slug/files': typeof AuthenticatedProjectsSlugFilesRoute
  '/projects/$slug/portfolio': typeof AuthenticatedProjectsSlugPortfolioRoute
  '/projects/$slug/screening': typeof AuthenticatedProjectsSlugScreeningRoute
  '/projects/$slug/transactions': typeof AuthenticatedProjectsSlugTransactionsRoute
  '/projects/$slug/workbench': typeof AuthenticatedProjectsSlugWorkbenchRoute
  '/tools/bankruptcy-screener/$filingId': typeof AuthenticatedToolsBankruptcyScreenerFilingIdRoute
  '/documents/$id/': typeof AuthenticatedDocumentsIdIndexRoute
  '/documents/search': typeof AuthenticatedDocumentsSearchIndexRoute
  '/projects/$slug/': typeof AuthenticatedProjectsSlugIndexRoute
  '/tools/bankruptcy-screener': typeof AuthenticatedToolsBankruptcyScreenerIndexRoute
  '/projects/$slug/insights/anomalies': typeof AuthenticatedProjectsSlugInsightsAnomaliesRoute
  '/projects/$slug/insights/categories': typeof AuthenticatedProjectsSlugInsightsCategoriesRoute
  '/projects/$slug/insights/checks': typeof AuthenticatedProjectsSlugInsightsChecksRoute
  '/projects/$slug/insights/coverage': typeof AuthenticatedProjectsSlugInsightsCoverageRoute
  '/projects/$slug/insights/duplicates': typeof AuthenticatedProjectsSlugInsightsDuplicatesRoute
  '/projects/$slug/insights/flow-of-funds': typeof AuthenticatedProjectsSlugInsightsFlowOfFundsRoute
  '/projects/$slug/insights/income': typeof AuthenticatedProjectsSlugInsightsIncomeRoute
  '/projects/$slug/insights/merchants': typeof AuthenticatedProjectsSlugInsightsMerchantsRoute
  '/projects/$slug/insights/network': typeof AuthenticatedProjectsSlugInsightsNetworkRoute
  '/projects/$slug/insights/reconciliation': typeof AuthenticatedProjectsSlugInsightsReconciliationRoute
  '/documents/folder/$slug': typeof AuthenticatedDocumentsFolderSlugIndexRoute
  '/projects/folder/$slug': typeof AuthenticatedProjectsFolderSlugIndexRoute
  '/projects/$slug/insights/duplicates/$groupId': typeof AuthenticatedProjectsSlugInsightsDuplicatesGroupIdRoute
}
export interface FileRoutesByTo {
  '/create-account': typeof CreateAccountRoute
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/user-sign-up': typeof UserSignUpRoute
  '/welcome': typeof WelcomeRoute
  '/billing': typeof AuthenticatedBillingRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/': typeof AuthenticatedIndexRoute
  '/credits/usage': typeof AuthenticatedCreditsUsageRoute
  '/updates/$slug': typeof AuthenticatedUpdatesSlugRoute
  '/credits': typeof AuthenticatedCreditsIndexRoute
  '/documents': typeof AuthenticatedDocumentsIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tools': typeof AuthenticatedToolsIndexRoute
  '/updates': typeof AuthenticatedUpdatesIndexRoute
  '/projects/$slug/insights': typeof AuthenticatedProjectsSlugInsightsRouteRouteWithChildren
  '/projects/$slug/analysis': typeof AuthenticatedProjectsSlugAnalysisRoute
  '/projects/$slug/checks': typeof AuthenticatedProjectsSlugChecksRoute
  '/projects/$slug/files': typeof AuthenticatedProjectsSlugFilesRoute
  '/projects/$slug/portfolio': typeof AuthenticatedProjectsSlugPortfolioRoute
  '/projects/$slug/screening': typeof AuthenticatedProjectsSlugScreeningRoute
  '/projects/$slug/transactions': typeof AuthenticatedProjectsSlugTransactionsRoute
  '/projects/$slug/workbench': typeof AuthenticatedProjectsSlugWorkbenchRoute
  '/tools/bankruptcy-screener/$filingId': typeof AuthenticatedToolsBankruptcyScreenerFilingIdRoute
  '/documents/$id': typeof AuthenticatedDocumentsIdIndexRoute
  '/documents/search': typeof AuthenticatedDocumentsSearchIndexRoute
  '/projects/$slug': typeof AuthenticatedProjectsSlugIndexRoute
  '/tools/bankruptcy-screener': typeof AuthenticatedToolsBankruptcyScreenerIndexRoute
  '/projects/$slug/insights/anomalies': typeof AuthenticatedProjectsSlugInsightsAnomaliesRoute
  '/projects/$slug/insights/categories': typeof AuthenticatedProjectsSlugInsightsCategoriesRoute
  '/projects/$slug/insights/checks': typeof AuthenticatedProjectsSlugInsightsChecksRoute
  '/projects/$slug/insights/coverage': typeof AuthenticatedProjectsSlugInsightsCoverageRoute
  '/projects/$slug/insights/duplicates': typeof AuthenticatedProjectsSlugInsightsDuplicatesRoute
  '/projects/$slug/insights/flow-of-funds': typeof AuthenticatedProjectsSlugInsightsFlowOfFundsRoute
  '/projects/$slug/insights/income': typeof AuthenticatedProjectsSlugInsightsIncomeRoute
  '/projects/$slug/insights/merchants': typeof AuthenticatedProjectsSlugInsightsMerchantsRoute
  '/projects/$slug/insights/network': typeof AuthenticatedProjectsSlugInsightsNetworkRoute
  '/projects/$slug/insights/reconciliation': typeof AuthenticatedProjectsSlugInsightsReconciliationRoute
  '/documents/folder/$slug': typeof AuthenticatedDocumentsFolderSlugIndexRoute
  '/projects/folder/$slug': typeof AuthenticatedProjectsFolderSlugIndexRoute
  '/projects/$slug/insights/duplicates/$groupId': typeof AuthenticatedProjectsSlugInsightsDuplicatesGroupIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/create-account': typeof CreateAccountRoute
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/user-sign-up': typeof UserSignUpRoute
  '/welcome': typeof WelcomeRoute
  '/_authenticated/credits': typeof AuthenticatedCreditsRouteRouteWithChildren
  '/_authenticated/documents': typeof AuthenticatedDocumentsRouteRouteWithChildren
  '/_authenticated/tools': typeof AuthenticatedToolsRouteRouteWithChildren
  '/_authenticated/billing': typeof AuthenticatedBillingRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/documents/$id': typeof AuthenticatedDocumentsIdRouteRouteWithChildren
  '/_authenticated/projects/$slug': typeof AuthenticatedProjectsSlugRouteRouteWithChildren
  '/_authenticated/credits/usage': typeof AuthenticatedCreditsUsageRoute
  '/_authenticated/updates/$slug': typeof AuthenticatedUpdatesSlugRoute
  '/_authenticated/credits/': typeof AuthenticatedCreditsIndexRoute
  '/_authenticated/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tools/': typeof AuthenticatedToolsIndexRoute
  '/_authenticated/updates/': typeof AuthenticatedUpdatesIndexRoute
  '/_authenticated/projects/$slug/insights': typeof AuthenticatedProjectsSlugInsightsRouteRouteWithChildren
  '/_authenticated/projects/$slug/analysis': typeof AuthenticatedProjectsSlugAnalysisRoute
  '/_authenticated/projects/$slug/checks': typeof AuthenticatedProjectsSlugChecksRoute
  '/_authenticated/projects/$slug/files': typeof AuthenticatedProjectsSlugFilesRoute
  '/_authenticated/projects/$slug/portfolio': typeof AuthenticatedProjectsSlugPortfolioRoute
  '/_authenticated/projects/$slug/screening': typeof AuthenticatedProjectsSlugScreeningRoute
  '/_authenticated/projects/$slug/transactions': typeof AuthenticatedProjectsSlugTransactionsRoute
  '/_authenticated/projects/$slug/workbench': typeof AuthenticatedProjectsSlugWorkbenchRoute
  '/_authenticated/tools/bankruptcy-screener/$filingId': typeof AuthenticatedToolsBankruptcyScreenerFilingIdRoute
  '/_authenticated/documents/$id/': typeof AuthenticatedDocumentsIdIndexRoute
  '/_authenticated/documents/search/': typeof AuthenticatedDocumentsSearchIndexRoute
  '/_authenticated/projects/$slug/': typeof AuthenticatedProjectsSlugIndexRoute
  '/_authenticated/tools/bankruptcy-screener/': typeof AuthenticatedToolsBankruptcyScreenerIndexRoute
  '/_authenticated/projects/$slug/insights/anomalies': typeof AuthenticatedProjectsSlugInsightsAnomaliesRoute
  '/_authenticated/projects/$slug/insights/categories': typeof AuthenticatedProjectsSlugInsightsCategoriesRoute
  '/_authenticated/projects/$slug/insights/checks': typeof AuthenticatedProjectsSlugInsightsChecksRoute
  '/_authenticated/projects/$slug/insights/coverage': typeof AuthenticatedProjectsSlugInsightsCoverageRoute
  '/_authenticated/projects/$slug/insights/duplicates': typeof AuthenticatedProjectsSlugInsightsDuplicatesRoute
  '/_authenticated/projects/$slug/insights/flow-of-funds': typeof AuthenticatedProjectsSlugInsightsFlowOfFundsRoute
  '/_authenticated/projects/$slug/insights/income': typeof AuthenticatedProjectsSlugInsightsIncomeRoute
  '/_authenticated/projects/$slug/insights/merchants': typeof AuthenticatedProjectsSlugInsightsMerchantsRoute
  '/_authenticated/projects/$slug/insights/network': typeof AuthenticatedProjectsSlugInsightsNetworkRoute
  '/_authenticated/projects/$slug/insights/reconciliation': typeof AuthenticatedProjectsSlugInsightsReconciliationRoute
  '/_authenticated/documents/folder/$slug/': typeof AuthenticatedDocumentsFolderSlugIndexRoute
  '/_authenticated/projects/folder/$slug/': typeof AuthenticatedProjectsFolderSlugIndexRoute
  '/_authenticated/projects/$slug/insights_/duplicates/$groupId': typeof AuthenticatedProjectsSlugInsightsDuplicatesGroupIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/create-account'
    | '/login'
    | '/sign-up'
    | '/user-sign-up'
    | '/welcome'
    | '/credits'
    | '/documents'
    | '/tools'
    | '/billing'
    | '/invitations/$token'
    | '/'
    | '/documents/$id'
    | '/projects/$slug'
    | '/credits/usage'
    | '/updates/$slug'
    | '/credits/'
    | '/documents/'
    | '/projects'
    | '/settings'
    | '/tools/'
    | '/updates'
    | '/projects/$slug/insights'
    | '/projects/$slug/analysis'
    | '/projects/$slug/checks'
    | '/projects/$slug/files'
    | '/projects/$slug/portfolio'
    | '/projects/$slug/screening'
    | '/projects/$slug/transactions'
    | '/projects/$slug/workbench'
    | '/tools/bankruptcy-screener/$filingId'
    | '/documents/$id/'
    | '/documents/search'
    | '/projects/$slug/'
    | '/tools/bankruptcy-screener'
    | '/projects/$slug/insights/anomalies'
    | '/projects/$slug/insights/categories'
    | '/projects/$slug/insights/checks'
    | '/projects/$slug/insights/coverage'
    | '/projects/$slug/insights/duplicates'
    | '/projects/$slug/insights/flow-of-funds'
    | '/projects/$slug/insights/income'
    | '/projects/$slug/insights/merchants'
    | '/projects/$slug/insights/network'
    | '/projects/$slug/insights/reconciliation'
    | '/documents/folder/$slug'
    | '/projects/folder/$slug'
    | '/projects/$slug/insights/duplicates/$groupId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/create-account'
    | '/login'
    | '/sign-up'
    | '/user-sign-up'
    | '/welcome'
    | '/billing'
    | '/invitations/$token'
    | '/'
    | '/credits/usage'
    | '/updates/$slug'
    | '/credits'
    | '/documents'
    | '/projects'
    | '/settings'
    | '/tools'
    | '/updates'
    | '/projects/$slug/insights'
    | '/projects/$slug/analysis'
    | '/projects/$slug/checks'
    | '/projects/$slug/files'
    | '/projects/$slug/portfolio'
    | '/projects/$slug/screening'
    | '/projects/$slug/transactions'
    | '/projects/$slug/workbench'
    | '/tools/bankruptcy-screener/$filingId'
    | '/documents/$id'
    | '/documents/search'
    | '/projects/$slug'
    | '/tools/bankruptcy-screener'
    | '/projects/$slug/insights/anomalies'
    | '/projects/$slug/insights/categories'
    | '/projects/$slug/insights/checks'
    | '/projects/$slug/insights/coverage'
    | '/projects/$slug/insights/duplicates'
    | '/projects/$slug/insights/flow-of-funds'
    | '/projects/$slug/insights/income'
    | '/projects/$slug/insights/merchants'
    | '/projects/$slug/insights/network'
    | '/projects/$slug/insights/reconciliation'
    | '/documents/folder/$slug'
    | '/projects/folder/$slug'
    | '/projects/$slug/insights/duplicates/$groupId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/create-account'
    | '/login'
    | '/sign-up'
    | '/user-sign-up'
    | '/welcome'
    | '/_authenticated/credits'
    | '/_authenticated/documents'
    | '/_authenticated/tools'
    | '/_authenticated/billing'
    | '/invitations/$token'
    | '/_authenticated/'
    | '/_authenticated/documents/$id'
    | '/_authenticated/projects/$slug'
    | '/_authenticated/credits/usage'
    | '/_authenticated/updates/$slug'
    | '/_authenticated/credits/'
    | '/_authenticated/documents/'
    | '/_authenticated/projects/'
    | '/_authenticated/settings/'
    | '/_authenticated/tools/'
    | '/_authenticated/updates/'
    | '/_authenticated/projects/$slug/insights'
    | '/_authenticated/projects/$slug/analysis'
    | '/_authenticated/projects/$slug/checks'
    | '/_authenticated/projects/$slug/files'
    | '/_authenticated/projects/$slug/portfolio'
    | '/_authenticated/projects/$slug/screening'
    | '/_authenticated/projects/$slug/transactions'
    | '/_authenticated/projects/$slug/workbench'
    | '/_authenticated/tools/bankruptcy-screener/$filingId'
    | '/_authenticated/documents/$id/'
    | '/_authenticated/documents/search/'
    | '/_authenticated/projects/$slug/'
    | '/_authenticated/tools/bankruptcy-screener/'
    | '/_authenticated/projects/$slug/insights/anomalies'
    | '/_authenticated/projects/$slug/insights/categories'
    | '/_authenticated/projects/$slug/insights/checks'
    | '/_authenticated/projects/$slug/insights/coverage'
    | '/_authenticated/projects/$slug/insights/duplicates'
    | '/_authenticated/projects/$slug/insights/flow-of-funds'
    | '/_authenticated/projects/$slug/insights/income'
    | '/_authenticated/projects/$slug/insights/merchants'
    | '/_authenticated/projects/$slug/insights/network'
    | '/_authenticated/projects/$slug/insights/reconciliation'
    | '/_authenticated/documents/folder/$slug/'
    | '/_authenticated/projects/folder/$slug/'
    | '/_authenticated/projects/$slug/insights_/duplicates/$groupId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  CreateAccountRoute: typeof CreateAccountRoute
  LoginRoute: typeof LoginRoute
  SignUpRoute: typeof SignUpRoute
  UserSignUpRoute: typeof UserSignUpRoute
  WelcomeRoute: typeof WelcomeRoute
  InvitationsTokenRoute: typeof InvitationsTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-sign-up': {
      id: '/user-sign-up'
      path: '/user-sign-up'
      fullPath: '/user-sign-up'
      preLoaderRoute: typeof UserSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create-account': {
      id: '/create-account'
      path: '/create-account'
      fullPath: '/create-account'
      preLoaderRoute: typeof CreateAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/invitations/$token': {
      id: '/invitations/$token'
      path: '/invitations/$token'
      fullPath: '/invitations/$token'
      preLoaderRoute: typeof InvitationsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/billing': {
      id: '/_authenticated/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthenticatedBillingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tools': {
      id: '/_authenticated/tools'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof AuthenticatedToolsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/documents': {
      id: '/_authenticated/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthenticatedDocumentsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/credits': {
      id: '/_authenticated/credits'
      path: '/credits'
      fullPath: '/credits'
      preLoaderRoute: typeof AuthenticatedCreditsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/updates/': {
      id: '/_authenticated/updates/'
      path: '/updates'
      fullPath: '/updates'
      preLoaderRoute: typeof AuthenticatedUpdatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tools/': {
      id: '/_authenticated/tools/'
      path: '/'
      fullPath: '/tools/'
      preLoaderRoute: typeof AuthenticatedToolsIndexRouteImport
      parentRoute: typeof AuthenticatedToolsRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/documents/': {
      id: '/_authenticated/documents/'
      path: '/'
      fullPath: '/documents/'
      preLoaderRoute: typeof AuthenticatedDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedDocumentsRouteRoute
    }
    '/_authenticated/credits/': {
      id: '/_authenticated/credits/'
      path: '/'
      fullPath: '/credits/'
      preLoaderRoute: typeof AuthenticatedCreditsIndexRouteImport
      parentRoute: typeof AuthenticatedCreditsRouteRoute
    }
    '/_authenticated/updates/$slug': {
      id: '/_authenticated/updates/$slug'
      path: '/updates/$slug'
      fullPath: '/updates/$slug'
      preLoaderRoute: typeof AuthenticatedUpdatesSlugRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/credits/usage': {
      id: '/_authenticated/credits/usage'
      path: '/usage'
      fullPath: '/credits/usage'
      preLoaderRoute: typeof AuthenticatedCreditsUsageRouteImport
      parentRoute: typeof AuthenticatedCreditsRouteRoute
    }
    '/_authenticated/projects/$slug': {
      id: '/_authenticated/projects/$slug'
      path: '/projects/$slug'
      fullPath: '/projects/$slug'
      preLoaderRoute: typeof AuthenticatedProjectsSlugRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/documents/$id': {
      id: '/_authenticated/documents/$id'
      path: '/$id'
      fullPath: '/documents/$id'
      preLoaderRoute: typeof AuthenticatedDocumentsIdRouteRouteImport
      parentRoute: typeof AuthenticatedDocumentsRouteRoute
    }
    '/_authenticated/tools/bankruptcy-screener/': {
      id: '/_authenticated/tools/bankruptcy-screener/'
      path: '/bankruptcy-screener'
      fullPath: '/tools/bankruptcy-screener'
      preLoaderRoute: typeof AuthenticatedToolsBankruptcyScreenerIndexRouteImport
      parentRoute: typeof AuthenticatedToolsRouteRoute
    }
    '/_authenticated/projects/$slug/': {
      id: '/_authenticated/projects/$slug/'
      path: '/'
      fullPath: '/projects/$slug/'
      preLoaderRoute: typeof AuthenticatedProjectsSlugIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugRouteRoute
    }
    '/_authenticated/documents/search/': {
      id: '/_authenticated/documents/search/'
      path: '/search'
      fullPath: '/documents/search'
      preLoaderRoute: typeof AuthenticatedDocumentsSearchIndexRouteImport
      parentRoute: typeof AuthenticatedDocumentsRouteRoute
    }
    '/_authenticated/documents/$id/': {
      id: '/_authenticated/documents/$id/'
      path: '/'
      fullPath: '/documents/$id/'
      preLoaderRoute: typeof AuthenticatedDocumentsIdIndexRouteImport
      parentRoute: typeof AuthenticatedDocumentsIdRouteRoute
    }
    '/_authenticated/tools/bankruptcy-screener/$filingId': {
      id: '/_authenticated/tools/bankruptcy-screener/$filingId'
      path: '/bankruptcy-screener/$filingId'
      fullPath: '/tools/bankruptcy-screener/$filingId'
      preLoaderRoute: typeof AuthenticatedToolsBankruptcyScreenerFilingIdRouteImport
      parentRoute: typeof AuthenticatedToolsRouteRoute
    }
    '/_authenticated/projects/$slug/workbench': {
      id: '/_authenticated/projects/$slug/workbench'
      path: '/workbench'
      fullPath: '/projects/$slug/workbench'
      preLoaderRoute: typeof AuthenticatedProjectsSlugWorkbenchRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugRouteRoute
    }
    '/_authenticated/projects/$slug/transactions': {
      id: '/_authenticated/projects/$slug/transactions'
      path: '/transactions'
      fullPath: '/projects/$slug/transactions'
      preLoaderRoute: typeof AuthenticatedProjectsSlugTransactionsRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugRouteRoute
    }
    '/_authenticated/projects/$slug/screening': {
      id: '/_authenticated/projects/$slug/screening'
      path: '/screening'
      fullPath: '/projects/$slug/screening'
      preLoaderRoute: typeof AuthenticatedProjectsSlugScreeningRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugRouteRoute
    }
    '/_authenticated/projects/$slug/portfolio': {
      id: '/_authenticated/projects/$slug/portfolio'
      path: '/portfolio'
      fullPath: '/projects/$slug/portfolio'
      preLoaderRoute: typeof AuthenticatedProjectsSlugPortfolioRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugRouteRoute
    }
    '/_authenticated/projects/$slug/files': {
      id: '/_authenticated/projects/$slug/files'
      path: '/files'
      fullPath: '/projects/$slug/files'
      preLoaderRoute: typeof AuthenticatedProjectsSlugFilesRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugRouteRoute
    }
    '/_authenticated/projects/$slug/checks': {
      id: '/_authenticated/projects/$slug/checks'
      path: '/checks'
      fullPath: '/projects/$slug/checks'
      preLoaderRoute: typeof AuthenticatedProjectsSlugChecksRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugRouteRoute
    }
    '/_authenticated/projects/$slug/analysis': {
      id: '/_authenticated/projects/$slug/analysis'
      path: '/analysis'
      fullPath: '/projects/$slug/analysis'
      preLoaderRoute: typeof AuthenticatedProjectsSlugAnalysisRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugRouteRoute
    }
    '/_authenticated/projects/$slug/insights': {
      id: '/_authenticated/projects/$slug/insights'
      path: '/insights'
      fullPath: '/projects/$slug/insights'
      preLoaderRoute: typeof AuthenticatedProjectsSlugInsightsRouteRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugRouteRoute
    }
    '/_authenticated/projects/folder/$slug/': {
      id: '/_authenticated/projects/folder/$slug/'
      path: '/projects/folder/$slug'
      fullPath: '/projects/folder/$slug'
      preLoaderRoute: typeof AuthenticatedProjectsFolderSlugIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/documents/folder/$slug/': {
      id: '/_authenticated/documents/folder/$slug/'
      path: '/folder/$slug'
      fullPath: '/documents/folder/$slug'
      preLoaderRoute: typeof AuthenticatedDocumentsFolderSlugIndexRouteImport
      parentRoute: typeof AuthenticatedDocumentsRouteRoute
    }
    '/_authenticated/projects/$slug/insights/reconciliation': {
      id: '/_authenticated/projects/$slug/insights/reconciliation'
      path: '/reconciliation'
      fullPath: '/projects/$slug/insights/reconciliation'
      preLoaderRoute: typeof AuthenticatedProjectsSlugInsightsReconciliationRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugInsightsRouteRoute
    }
    '/_authenticated/projects/$slug/insights/network': {
      id: '/_authenticated/projects/$slug/insights/network'
      path: '/network'
      fullPath: '/projects/$slug/insights/network'
      preLoaderRoute: typeof AuthenticatedProjectsSlugInsightsNetworkRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugInsightsRouteRoute
    }
    '/_authenticated/projects/$slug/insights/merchants': {
      id: '/_authenticated/projects/$slug/insights/merchants'
      path: '/merchants'
      fullPath: '/projects/$slug/insights/merchants'
      preLoaderRoute: typeof AuthenticatedProjectsSlugInsightsMerchantsRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugInsightsRouteRoute
    }
    '/_authenticated/projects/$slug/insights/income': {
      id: '/_authenticated/projects/$slug/insights/income'
      path: '/income'
      fullPath: '/projects/$slug/insights/income'
      preLoaderRoute: typeof AuthenticatedProjectsSlugInsightsIncomeRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugInsightsRouteRoute
    }
    '/_authenticated/projects/$slug/insights/flow-of-funds': {
      id: '/_authenticated/projects/$slug/insights/flow-of-funds'
      path: '/flow-of-funds'
      fullPath: '/projects/$slug/insights/flow-of-funds'
      preLoaderRoute: typeof AuthenticatedProjectsSlugInsightsFlowOfFundsRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugInsightsRouteRoute
    }
    '/_authenticated/projects/$slug/insights/duplicates': {
      id: '/_authenticated/projects/$slug/insights/duplicates'
      path: '/duplicates'
      fullPath: '/projects/$slug/insights/duplicates'
      preLoaderRoute: typeof AuthenticatedProjectsSlugInsightsDuplicatesRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugInsightsRouteRoute
    }
    '/_authenticated/projects/$slug/insights/coverage': {
      id: '/_authenticated/projects/$slug/insights/coverage'
      path: '/coverage'
      fullPath: '/projects/$slug/insights/coverage'
      preLoaderRoute: typeof AuthenticatedProjectsSlugInsightsCoverageRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugInsightsRouteRoute
    }
    '/_authenticated/projects/$slug/insights/checks': {
      id: '/_authenticated/projects/$slug/insights/checks'
      path: '/checks'
      fullPath: '/projects/$slug/insights/checks'
      preLoaderRoute: typeof AuthenticatedProjectsSlugInsightsChecksRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugInsightsRouteRoute
    }
    '/_authenticated/projects/$slug/insights/categories': {
      id: '/_authenticated/projects/$slug/insights/categories'
      path: '/categories'
      fullPath: '/projects/$slug/insights/categories'
      preLoaderRoute: typeof AuthenticatedProjectsSlugInsightsCategoriesRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugInsightsRouteRoute
    }
    '/_authenticated/projects/$slug/insights/anomalies': {
      id: '/_authenticated/projects/$slug/insights/anomalies'
      path: '/anomalies'
      fullPath: '/projects/$slug/insights/anomalies'
      preLoaderRoute: typeof AuthenticatedProjectsSlugInsightsAnomaliesRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugInsightsRouteRoute
    }
    '/_authenticated/projects/$slug/insights_/duplicates/$groupId': {
      id: '/_authenticated/projects/$slug/insights_/duplicates/$groupId'
      path: '/insights/duplicates/$groupId'
      fullPath: '/projects/$slug/insights/duplicates/$groupId'
      preLoaderRoute: typeof AuthenticatedProjectsSlugInsightsDuplicatesGroupIdRouteImport
      parentRoute: typeof AuthenticatedProjectsSlugRouteRoute
    }
  }
}

interface AuthenticatedCreditsRouteRouteChildren {
  AuthenticatedCreditsUsageRoute: typeof AuthenticatedCreditsUsageRoute
  AuthenticatedCreditsIndexRoute: typeof AuthenticatedCreditsIndexRoute
}

const AuthenticatedCreditsRouteRouteChildren: AuthenticatedCreditsRouteRouteChildren =
  {
    AuthenticatedCreditsUsageRoute: AuthenticatedCreditsUsageRoute,
    AuthenticatedCreditsIndexRoute: AuthenticatedCreditsIndexRoute,
  }

const AuthenticatedCreditsRouteRouteWithChildren =
  AuthenticatedCreditsRouteRoute._addFileChildren(
    AuthenticatedCreditsRouteRouteChildren,
  )

interface AuthenticatedDocumentsIdRouteRouteChildren {
  AuthenticatedDocumentsIdIndexRoute: typeof AuthenticatedDocumentsIdIndexRoute
}

const AuthenticatedDocumentsIdRouteRouteChildren: AuthenticatedDocumentsIdRouteRouteChildren =
  {
    AuthenticatedDocumentsIdIndexRoute: AuthenticatedDocumentsIdIndexRoute,
  }

const AuthenticatedDocumentsIdRouteRouteWithChildren =
  AuthenticatedDocumentsIdRouteRoute._addFileChildren(
    AuthenticatedDocumentsIdRouteRouteChildren,
  )

interface AuthenticatedDocumentsRouteRouteChildren {
  AuthenticatedDocumentsIdRouteRoute: typeof AuthenticatedDocumentsIdRouteRouteWithChildren
  AuthenticatedDocumentsIndexRoute: typeof AuthenticatedDocumentsIndexRoute
  AuthenticatedDocumentsSearchIndexRoute: typeof AuthenticatedDocumentsSearchIndexRoute
  AuthenticatedDocumentsFolderSlugIndexRoute: typeof AuthenticatedDocumentsFolderSlugIndexRoute
}

const AuthenticatedDocumentsRouteRouteChildren: AuthenticatedDocumentsRouteRouteChildren =
  {
    AuthenticatedDocumentsIdRouteRoute:
      AuthenticatedDocumentsIdRouteRouteWithChildren,
    AuthenticatedDocumentsIndexRoute: AuthenticatedDocumentsIndexRoute,
    AuthenticatedDocumentsSearchIndexRoute:
      AuthenticatedDocumentsSearchIndexRoute,
    AuthenticatedDocumentsFolderSlugIndexRoute:
      AuthenticatedDocumentsFolderSlugIndexRoute,
  }

const AuthenticatedDocumentsRouteRouteWithChildren =
  AuthenticatedDocumentsRouteRoute._addFileChildren(
    AuthenticatedDocumentsRouteRouteChildren,
  )

interface AuthenticatedToolsRouteRouteChildren {
  AuthenticatedToolsIndexRoute: typeof AuthenticatedToolsIndexRoute
  AuthenticatedToolsBankruptcyScreenerFilingIdRoute: typeof AuthenticatedToolsBankruptcyScreenerFilingIdRoute
  AuthenticatedToolsBankruptcyScreenerIndexRoute: typeof AuthenticatedToolsBankruptcyScreenerIndexRoute
}

const AuthenticatedToolsRouteRouteChildren: AuthenticatedToolsRouteRouteChildren =
  {
    AuthenticatedToolsIndexRoute: AuthenticatedToolsIndexRoute,
    AuthenticatedToolsBankruptcyScreenerFilingIdRoute:
      AuthenticatedToolsBankruptcyScreenerFilingIdRoute,
    AuthenticatedToolsBankruptcyScreenerIndexRoute:
      AuthenticatedToolsBankruptcyScreenerIndexRoute,
  }

const AuthenticatedToolsRouteRouteWithChildren =
  AuthenticatedToolsRouteRoute._addFileChildren(
    AuthenticatedToolsRouteRouteChildren,
  )

interface AuthenticatedProjectsSlugInsightsRouteRouteChildren {
  AuthenticatedProjectsSlugInsightsAnomaliesRoute: typeof AuthenticatedProjectsSlugInsightsAnomaliesRoute
  AuthenticatedProjectsSlugInsightsCategoriesRoute: typeof AuthenticatedProjectsSlugInsightsCategoriesRoute
  AuthenticatedProjectsSlugInsightsChecksRoute: typeof AuthenticatedProjectsSlugInsightsChecksRoute
  AuthenticatedProjectsSlugInsightsCoverageRoute: typeof AuthenticatedProjectsSlugInsightsCoverageRoute
  AuthenticatedProjectsSlugInsightsDuplicatesRoute: typeof AuthenticatedProjectsSlugInsightsDuplicatesRoute
  AuthenticatedProjectsSlugInsightsFlowOfFundsRoute: typeof AuthenticatedProjectsSlugInsightsFlowOfFundsRoute
  AuthenticatedProjectsSlugInsightsIncomeRoute: typeof AuthenticatedProjectsSlugInsightsIncomeRoute
  AuthenticatedProjectsSlugInsightsMerchantsRoute: typeof AuthenticatedProjectsSlugInsightsMerchantsRoute
  AuthenticatedProjectsSlugInsightsNetworkRoute: typeof AuthenticatedProjectsSlugInsightsNetworkRoute
  AuthenticatedProjectsSlugInsightsReconciliationRoute: typeof AuthenticatedProjectsSlugInsightsReconciliationRoute
}

const AuthenticatedProjectsSlugInsightsRouteRouteChildren: AuthenticatedProjectsSlugInsightsRouteRouteChildren =
  {
    AuthenticatedProjectsSlugInsightsAnomaliesRoute:
      AuthenticatedProjectsSlugInsightsAnomaliesRoute,
    AuthenticatedProjectsSlugInsightsCategoriesRoute:
      AuthenticatedProjectsSlugInsightsCategoriesRoute,
    AuthenticatedProjectsSlugInsightsChecksRoute:
      AuthenticatedProjectsSlugInsightsChecksRoute,
    AuthenticatedProjectsSlugInsightsCoverageRoute:
      AuthenticatedProjectsSlugInsightsCoverageRoute,
    AuthenticatedProjectsSlugInsightsDuplicatesRoute:
      AuthenticatedProjectsSlugInsightsDuplicatesRoute,
    AuthenticatedProjectsSlugInsightsFlowOfFundsRoute:
      AuthenticatedProjectsSlugInsightsFlowOfFundsRoute,
    AuthenticatedProjectsSlugInsightsIncomeRoute:
      AuthenticatedProjectsSlugInsightsIncomeRoute,
    AuthenticatedProjectsSlugInsightsMerchantsRoute:
      AuthenticatedProjectsSlugInsightsMerchantsRoute,
    AuthenticatedProjectsSlugInsightsNetworkRoute:
      AuthenticatedProjectsSlugInsightsNetworkRoute,
    AuthenticatedProjectsSlugInsightsReconciliationRoute:
      AuthenticatedProjectsSlugInsightsReconciliationRoute,
  }

const AuthenticatedProjectsSlugInsightsRouteRouteWithChildren =
  AuthenticatedProjectsSlugInsightsRouteRoute._addFileChildren(
    AuthenticatedProjectsSlugInsightsRouteRouteChildren,
  )

interface AuthenticatedProjectsSlugRouteRouteChildren {
  AuthenticatedProjectsSlugInsightsRouteRoute: typeof AuthenticatedProjectsSlugInsightsRouteRouteWithChildren
  AuthenticatedProjectsSlugAnalysisRoute: typeof AuthenticatedProjectsSlugAnalysisRoute
  AuthenticatedProjectsSlugChecksRoute: typeof AuthenticatedProjectsSlugChecksRoute
  AuthenticatedProjectsSlugFilesRoute: typeof AuthenticatedProjectsSlugFilesRoute
  AuthenticatedProjectsSlugPortfolioRoute: typeof AuthenticatedProjectsSlugPortfolioRoute
  AuthenticatedProjectsSlugScreeningRoute: typeof AuthenticatedProjectsSlugScreeningRoute
  AuthenticatedProjectsSlugTransactionsRoute: typeof AuthenticatedProjectsSlugTransactionsRoute
  AuthenticatedProjectsSlugWorkbenchRoute: typeof AuthenticatedProjectsSlugWorkbenchRoute
  AuthenticatedProjectsSlugIndexRoute: typeof AuthenticatedProjectsSlugIndexRoute
  AuthenticatedProjectsSlugInsightsDuplicatesGroupIdRoute: typeof AuthenticatedProjectsSlugInsightsDuplicatesGroupIdRoute
}

const AuthenticatedProjectsSlugRouteRouteChildren: AuthenticatedProjectsSlugRouteRouteChildren =
  {
    AuthenticatedProjectsSlugInsightsRouteRoute:
      AuthenticatedProjectsSlugInsightsRouteRouteWithChildren,
    AuthenticatedProjectsSlugAnalysisRoute:
      AuthenticatedProjectsSlugAnalysisRoute,
    AuthenticatedProjectsSlugChecksRoute: AuthenticatedProjectsSlugChecksRoute,
    AuthenticatedProjectsSlugFilesRoute: AuthenticatedProjectsSlugFilesRoute,
    AuthenticatedProjectsSlugPortfolioRoute:
      AuthenticatedProjectsSlugPortfolioRoute,
    AuthenticatedProjectsSlugScreeningRoute:
      AuthenticatedProjectsSlugScreeningRoute,
    AuthenticatedProjectsSlugTransactionsRoute:
      AuthenticatedProjectsSlugTransactionsRoute,
    AuthenticatedProjectsSlugWorkbenchRoute:
      AuthenticatedProjectsSlugWorkbenchRoute,
    AuthenticatedProjectsSlugIndexRoute: AuthenticatedProjectsSlugIndexRoute,
    AuthenticatedProjectsSlugInsightsDuplicatesGroupIdRoute:
      AuthenticatedProjectsSlugInsightsDuplicatesGroupIdRoute,
  }

const AuthenticatedProjectsSlugRouteRouteWithChildren =
  AuthenticatedProjectsSlugRouteRoute._addFileChildren(
    AuthenticatedProjectsSlugRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedCreditsRouteRoute: typeof AuthenticatedCreditsRouteRouteWithChildren
  AuthenticatedDocumentsRouteRoute: typeof AuthenticatedDocumentsRouteRouteWithChildren
  AuthenticatedToolsRouteRoute: typeof AuthenticatedToolsRouteRouteWithChildren
  AuthenticatedBillingRoute: typeof AuthenticatedBillingRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedProjectsSlugRouteRoute: typeof AuthenticatedProjectsSlugRouteRouteWithChildren
  AuthenticatedUpdatesSlugRoute: typeof AuthenticatedUpdatesSlugRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedUpdatesIndexRoute: typeof AuthenticatedUpdatesIndexRoute
  AuthenticatedProjectsFolderSlugIndexRoute: typeof AuthenticatedProjectsFolderSlugIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedCreditsRouteRoute: AuthenticatedCreditsRouteRouteWithChildren,
  AuthenticatedDocumentsRouteRoute:
    AuthenticatedDocumentsRouteRouteWithChildren,
  AuthenticatedToolsRouteRoute: AuthenticatedToolsRouteRouteWithChildren,
  AuthenticatedBillingRoute: AuthenticatedBillingRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedProjectsSlugRouteRoute:
    AuthenticatedProjectsSlugRouteRouteWithChildren,
  AuthenticatedUpdatesSlugRoute: AuthenticatedUpdatesSlugRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedUpdatesIndexRoute: AuthenticatedUpdatesIndexRoute,
  AuthenticatedProjectsFolderSlugIndexRoute:
    AuthenticatedProjectsFolderSlugIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  CreateAccountRoute: CreateAccountRoute,
  LoginRoute: LoginRoute,
  SignUpRoute: SignUpRoute,
  UserSignUpRoute: UserSignUpRoute,
  WelcomeRoute: WelcomeRoute,
  InvitationsTokenRoute: InvitationsTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
